import styled, { keyframes, css } from 'styled-components';
import { device } from '../../styles/devices';
import type { ThemeProps } from '../../types';
import {
  SYS_PAGE_MARGIN_LG,
  SYS_SIZE_FIXED_1200,
  SYS_SIZE_FIXED_400,
  SYS_SIZE_FIXED_800,
} from '@oneaudi/unified-web-common';

interface StyleProps {
  width?: string;
  isDealerNotesModal?: boolean;
}

const modalContainerAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20vh);
  }
  100% {
    opacity: initial;
    transform: initial;
  }
`;

const modalBackdropAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: initial;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  padding: 0;
  z-index: 1000;
  -webkit-transform: translate3d(0, 0, 0);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  animation-name: ${modalBackdropAnimation};
  animation-duration: 400ms;
  animation-iteration-count: 1;
  animation-timing-function: cubic-brezier(0.35, 0.29, 0.05, 0.95);
  animation-fill-mode: forwards;
  @media ${device.tablet} {
    padding: 30px 20px;
  }
  ${({ isDealerNotesModal }: StyleProps) =>
    isDealerNotesModal &&
    css`
      @media ${device.tablet} {
        padding-right: 0;
        padding-left: 0;
      }
    `}
`;

export const ModalContainer = styled.div`
  position: relative;
  width: ${({ width }: StyleProps) => width || '100%'};
  max-width: 80%;

  margin: 0 auto;
  display: flex;
  padding: 80px 30px;
  flex-direction: column;
  height: 100vh;
  background-color: ${(props: { theme: ThemeProps }) => props.theme.sys.color.surface.neutral[800]};
  border: 1px solid ${(props: { theme: ThemeProps }) => props.theme.sys.color.surface.neutral[800]};
  overflow-y: auto;
  animation-name: ${modalContainerAnimation};
  animation-duration: 400ms;
  animation-iteration-count: 1;
  animation-timing-function: cubic-brezier(0.35, 0.29, 0.05, 0.95);
  animation-fill-mode: forwards;
  @media ${device.tablet} {
    height: auto;
    padding: 24px 80px;
  }
  ${({ isDealerNotesModal }: StyleProps) =>
    isDealerNotesModal &&
    css`
      padding: ${SYS_SIZE_FIXED_1200} ${SYS_SIZE_FIXED_400} ${SYS_SIZE_FIXED_400}
        ${SYS_SIZE_FIXED_400};
      @media ${device.tablet} {
        padding: ${SYS_SIZE_FIXED_800} ${SYS_SIZE_FIXED_1200} ${SYS_SIZE_FIXED_1200}
          ${SYS_SIZE_FIXED_1200};
      }
      @media ${device.laptop} {
        max-width: 1024px;
        padding: ${SYS_SIZE_FIXED_1200} ${SYS_PAGE_MARGIN_LG} ${SYS_PAGE_MARGIN_LG}
          ${SYS_PAGE_MARGIN_LG};
      }
    `}
`;

export const CloseModalButton = styled.button`
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  position: absolute;
  top: 0;
  right: 0;
  height: 48px;
  width: 48px;
`;
